<div class="hx-rich-text-editor__wrapper">
  <!-- HTML mode: delegate to HxJoditEditor -->
  @if (format() === 'html') {
    <hx-jodit-editor
      #joditEditor
      class="hx-rich-text-editor__html-editor"
      [config]="emailJoditConfig"
      [customButtons]="customButtons()"
      [debounceMs]="debounceMs()"
      [disabled]="disabledState()"
      [height]="height()"
      [maxLength]="maxLength()"
      [minLength]="minLength()"
      [placeholder]="placeholder()"
      [readonly]="readonly()"
      [sanitize]="sanitize()"
      [toolbar]="toolbar()"
      (contentChanged)="contentChanged.emit($event)"
      (editorCreated)="onEditorCreated($event)"
      (valueChange)="onHtmlValueChange($event)" />
  } @else {
    <!-- Text mode: native textarea with SMS counter -->
    <div class="hx-rich-text-editor__text-editor" [style.height]="textEditorHeight()">
      <textarea
        #textInput
        class="hx-rich-text-editor__textarea"
        [attr.aria-label]="ariaLabel() || 'SMS message editor'"
        [disabled]="disabledState() || null"
        [placeholder]="placeholder() || 'Type your message here… (plain text only)'"
        [readOnly]="readonly()"
        [rows]="rows()"
        [value]="textValue()"
        (blur)="markTouched()"
        (input)="onTextInput($event)"></textarea>

      <div class="hx-rich-text-editor__sms-bar">
        <span class="hx-rich-text-editor__sms-chars">{{ charLabel() }}</span>
        <span class="hx-rich-text-editor__sms-segments">{{ segmentLabel() }}</span>
      </div>

      @if (atCap()) {
        <div class="hx-rich-text-editor__sms-warning" role="alert">
          Max {{ smsStats().maxSegments }} segments ({{ smsStats().hardCap }} chars
          {{ smsStats().gsm ? 'GSM-7' : 'Unicode' }}) reached. Input is capped.
        </div>
      }
    </div>
  }

  <!-- Shared variable side panel (both modes) -->
  @if (variables().length > 0) {
    <hx-variable-side-panel
      class="hx-rich-text-editor__side-panel"
      [variables]="variables()"
      (variableSelected)="onVariableSelected($event)" />
  }
</div>
